const HIRING_MANAGER_PORTAL_COMPANY_ID_KEY = "hiring-manager-portal-company-id";
const HIRING_MANAGER_PORTAL_USER_ID_KEY = "hiring-manager-portal-user-id";
const HIRING_MANAGER_PORTAL_HASH_KEY = "hiring-manager-portal-hash";

export const getHiringManagerPortalHash = () => {
  if (typeof window === "undefined") return;
  return sessionStorage.getItem(HIRING_MANAGER_PORTAL_HASH_KEY);
};

export const setHiringManagerPortalHash = (hash) => {
  if (typeof window === "undefined") return;
  if (hash) sessionStorage.setItem(HIRING_MANAGER_PORTAL_HASH_KEY, hash);
  else sessionStorage.removeItem(HIRING_MANAGER_PORTAL_HASH_KEY);
};

export const clearHiringManagerPortalHash = () => {
  if (typeof window === "undefined") return;
  sessionStorage.removeItem(HIRING_MANAGER_PORTAL_HASH_KEY);
};

export const getCompanyIdBySession = () => {
  if (typeof window === "undefined") return;
  return sessionStorage.getItem(HIRING_MANAGER_PORTAL_COMPANY_ID_KEY);
};

export const setCompanyIdBySession = (companyId) => {
  if (typeof window === "undefined") return;
  if (companyId != null && companyId !== "") {
    sessionStorage.setItem(HIRING_MANAGER_PORTAL_COMPANY_ID_KEY, companyId);
  } else {
    sessionStorage.removeItem(HIRING_MANAGER_PORTAL_COMPANY_ID_KEY);
  }
};

export const getUserIdBySession = () => {
  if (typeof window === "undefined") return;
  return sessionStorage.getItem(HIRING_MANAGER_PORTAL_USER_ID_KEY);
};

export const setUserIdBySession = (userId) => {
  if (typeof window === "undefined") return;
  if (userId != null && userId !== "") {
    sessionStorage.setItem(HIRING_MANAGER_PORTAL_USER_ID_KEY, userId);
  } else {
    sessionStorage.removeItem(HIRING_MANAGER_PORTAL_USER_ID_KEY);
  }
};

/** Set company id and user id in session from hiring manager portal dashboard response entity */
export const setHiringManagerPortalSessionFromResponse = (entity) => {
  if (!entity) return;
  const companyId = entity.companyId ?? null;
  const userId = entity.currentUserDetails?.id ?? null;
  if (companyId) setCompanyIdBySession(companyId);
  if (userId) setUserIdBySession(userId);
};
